import { RTKQueryTag } from 'src/common/constants';
import type { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

import type { UserOccupationData, UserOccupationParams } from './user-occupation.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserOccupation: builder.query<ApiResponse<UserOccupationData>, UserOccupationParams>({
      query: ({ page, limit, searchText = '', sortOrderText = '', sortColumn = '' }) => ({
        url: 'admin/users/occupation',
        params: { page, limit, searchText, sortOrderText, sortColumn },
      }),
      providesTags: [RTKQueryTag.UserOccupation],
    }),
  }),
});

export const { useGetUserOccupationQuery } = extendedApiSlice;
